// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var Tooltip = require("../../reason/common/Tooltip.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var IconButton = require("../../reason/common/IconButton.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
var Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var AccountMemberUtils = require("./AccountMemberUtils.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");
var SubusersPageAccountsListItem_member_graphql = require("../../__generated__/SubusersPageAccountsListItem_member_graphql.bs.js");
var SubusersPageAccountsListItem_account_graphql = require("../../__generated__/SubusersPageAccountsListItem_account_graphql.bs.js");
var SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql = require("../../__generated__/SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.bs.js");
var SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql = require("../../__generated__/SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.bs.js");

function SubusersPageAccountsListItem$ConfirmRemoveDialog(props) {
  var name = props.name;
  var onCancel = props.onCancel;
  var onConfirm = props.onConfirm;
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsx(ConfirmDialog.make, {
                        title: "Remove " + name + "?",
                        ariaLabel: "Confirm removal of " + name,
                        body: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                JsxRuntime.jsx(Text__Jsx3.make, {
                                      lineHeight: {
                                        NAME: "float",
                                        VAL: 1.5
                                      },
                                      children: name + " will be permanently removed from your account. You will assume ownership of all their clients and messages."
                                    }),
                                JsxRuntime.jsx("br", {}),
                                JsxRuntime.jsx(Text__Jsx3.make, {
                                      fontWeight: "bold",
                                      children: "Once confirmed, the removal is not reversible."
                                    })
                              ]
                            }),
                        isOpen: props.isOpen,
                        onCancel: onCancel,
                        cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              onClick: (function (param) {
                                  onCancel();
                                }),
                              children: "Cancel"
                            }),
                        confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                              onClick: (function (param) {
                                  onConfirm();
                                }),
                              children: "Yes, remove them"
                            })
                      }))
            });
}

var ConfirmRemoveDialog = {
  $$Text: undefined,
  View: undefined,
  Buttons: undefined,
  make: SubusersPageAccountsListItem$ConfirmRemoveDialog
};

var validators = {
  role: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: (function (param) {
        var role = param.role;
        if (role !== undefined) {
          return {
                  TAG: "Ok",
                  _0: role
                };
        } else {
          return {
                  TAG: "Error",
                  _0: "is required"
                };
        }
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          role: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            role: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.role;
  var match$1;
  match$1 = typeof match !== "object" ? validators.role.validate(input) : match._0;
  if (match$1.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              role: match$1._0
            },
            fieldsStatuses: {
              role: {
                TAG: "Dirty",
                _0: match$1,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: "Invalid",
            fieldsStatuses: {
              role: {
                TAG: "Dirty",
                _0: match$1,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurRoleField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.role, validators.role, (function (status) {
                          return {
                                  role: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateRoleField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.role, state.submissionStatus, validators.role, (function (status) {
                                    return {
                                            role: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                role: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                role: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: map(error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateRole: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateRoleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurRole: (function () {
              dispatch("BlurRoleField");
            }),
          roleResult: Formality.exposeFieldResult(state.fieldsStatuses.role),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.role;
              if (typeof tmp !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertFragment = SubusersPageAccountsListItem_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, SubusersPageAccountsListItem_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

var AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var accountMemberRole_decode = SubusersPageAccountsListItem_member_graphql.Utils.accountMemberRole_decode;

var convertFragment$1 = SubusersPageAccountsListItem_member_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, SubusersPageAccountsListItem_member_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

var MemberFragment_accountMemberRole_fromString = SubusersPageAccountsListItem_member_graphql.Utils.accountMemberRole_fromString;

var MemberFragment = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: MemberFragment_accountMemberRole_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertVariables = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Internal.convertVariables;

var convertResponse = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables, SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateMemberV5Mutation_accountMemberRoleInput_decode = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Utils.accountMemberRoleInput_decode;

var UpdateMemberV5Mutation_accountMemberRoleInput_fromString = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Utils.accountMemberRoleInput_fromString;

var UpdateMemberV5Mutation = {
  accountMemberRoleInput_decode: UpdateMemberV5Mutation_accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: UpdateMemberV5Mutation_accountMemberRoleInput_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

var convertVariables$1 = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertVariables;

var convertResponse$1 = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$3 = RescriptRelay_Mutation.useMutation(convertVariables$1, SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var RemoveMemberV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$3
};

function SubusersPageAccountsListItem(props) {
  var currentUserRole = props.currentUserRole;
  var match = use$2();
  var updateMember = match[0];
  var match$1 = use$3();
  var removeMember = match$1[0];
  var member = use$1(props.member);
  var account = use(props.account);
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsEditing = match$2[1];
  var form = useForm({
        role: Core__Option.flatMap(Core__Option.flatMap(member.role, (function (v) {
                    return accountMemberRole_decode(v);
                  })), (function (role) {
                switch (role) {
                  case "ASSISTANT" :
                      return "ASSISTANT";
                  case "ASSOCIATE" :
                      return "ASSOCIATE";
                  case "BUYER_SPECIALIST" :
                      return "BUYER_SPECIALIST";
                  case "CLIENT_CARE_COORDINATOR" :
                      return "CLIENT_CARE_COORDINATOR";
                  case "INSIDE_SALES_AGENT" :
                      return "INSIDE_SALES_AGENT";
                  case "LISTING_MANAGER" :
                      return "LISTING_MANAGER";
                  case "LISTING_SPECIALIST" :
                      return "LISTING_SPECIALIST";
                  case "MARKETING_SPECIALIST" :
                      return "MARKETING_SPECIALIST";
                  case "OPERATIONS_MANAGER" :
                      return "OPERATIONS_MANAGER";
                  case "PARTNER" :
                      return "PARTNER";
                  case "SHOWING_ASSISTANT" :
                      return "SHOWING_ASSISTANT";
                  case "TRANSACTION_COORDINATOR" :
                      return "TRANSACTION_COORDINATOR";
                  case "OWNER" :
                  case "UNKNOWN" :
                      return ;
                  
                }
              }))
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          updateMember({
                input: {
                  id: member.id,
                  role: param.role
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var updateMemberV5 = param.updateMemberV5;
                  if (updateMemberV5 !== undefined && updateMemberV5.__typename === "AccountMemberUpdated") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure("Error updating data. Please refresh and try again...");
                  }
                }), undefined, undefined);
        }));
  var match$3 = member.agent;
  var firstName = match$3.firstName;
  var name;
  if (firstName !== undefined) {
    var lastName = match$3.lastName;
    name = lastName !== undefined ? firstName + " " + lastName : firstName;
  } else {
    var lastName$1 = match$3.lastName;
    name = lastName$1 !== undefined ? lastName$1 : match$3.displayName;
  }
  var match$4 = member.role;
  var memberCanBeEdited = match$4 !== undefined && (match$4 === "TRANSACTION_COORDINATOR" || match$4 === "SHOWING_ASSISTANT" || match$4 === "PARTNER" || match$4 === "OWNER" || match$4 === "OPERATIONS_MANAGER" || match$4 === "MARKETING_SPECIALIST" || match$4 === "LISTING_SPECIALIST" || match$4 === "LISTING_MANAGER" || match$4 === "INSIDE_SALES_AGENT" || match$4 === "CLIENT_CARE_COORDINATOR" || match$4 === "BUYER_SPECIALIST" || match$4 === "ASSOCIATE" || match$4 === "ASSISTANT" || match$4 === "UNKNOWN") && match$4 === "OWNER" ? false : true;
  var canEdit = currentUserRole !== undefined && (currentUserRole === "TRANSACTION_COORDINATOR" || currentUserRole === "SHOWING_ASSISTANT" || currentUserRole === "PARTNER" || currentUserRole === "OWNER" || currentUserRole === "OPERATIONS_MANAGER" || currentUserRole === "MARKETING_SPECIALIST" || currentUserRole === "LISTING_SPECIALIST" || currentUserRole === "LISTING_MANAGER" || currentUserRole === "INSIDE_SALES_AGENT" || currentUserRole === "CLIENT_CARE_COORDINATOR" || currentUserRole === "BUYER_SPECIALIST" || currentUserRole === "ASSOCIATE" || currentUserRole === "ASSISTANT" || currentUserRole === "UNKNOWN") && currentUserRole === "OWNER" ? true : false;
  var match$5 = SystemMessages.useSystemMessages();
  var addMessage = match$5.addMessage;
  var addErrorMessage = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem removing the member. Please try again or contact us.", 5000, undefined, undefined));
  };
  var addSuccessMessage = function () {
    addMessage(SystemMessages.Message.make(undefined, "info", "The member was removed successfully", 5000, undefined, undefined));
  };
  var removeMember$1 = function () {
    removeMember({
          connections: [SubusersPageAccountsList_account_graphql.makeConnectionId(account.__id)],
          input: {
            id: member.id
          }
        }, undefined, undefined, undefined, (function (response, param) {
            var match = response.removeMemberV5;
            if (match !== undefined && match.__typename === "AccountMemberRemoved") {
              return addSuccessMessage();
            } else {
              return addErrorMessage();
            }
          }), undefined, undefined);
  };
  var match$6 = React.useState(function () {
        return false;
      });
  var setConfirmRemoveDialogOpen = match$6[1];
  var match$7 = member.agent.profilePhoto;
  var tmp;
  if (match$2[0]) {
    var match$8 = form.roleResult;
    var tmp$1;
    tmp$1 = match$8 !== undefined ? (
        match$8.TAG === "Ok" ? "Ok" : "Error"
      ) : undefined;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                  status: form.status,
                  submissionErrorToString: (function (v) {
                      return v;
                    }),
                  onSuccessMessage: "Account updated",
                  resetForm: (function () {
                      form.reset();
                      setIsEditing(function (param) {
                            return false;
                          });
                    }),
                  dismissSubmissionResult: form.dismissSubmissionResult
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: "First name:",
                                className: "font-semibold"
                              }),
                          className: "col-span-1"
                        }),
                    JsxRuntime.jsx("div", {
                          children: Core__Option.getOr(member.agent.firstName, ""),
                          className: "col-span-3"
                        })
                  ],
                  className: "grid grid-cols-4 gap-4"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: "Last name:",
                                className: "font-semibold"
                              }),
                          className: "col-span-1"
                        }),
                    JsxRuntime.jsx("div", {
                          children: Core__Option.getOr(member.agent.lastName, ""),
                          className: "col-span-3"
                        })
                  ],
                  className: "grid grid-cols-4 gap-4"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: "Email:",
                                className: "font-semibold"
                              }),
                          className: "col-span-1"
                        }),
                    JsxRuntime.jsx("div", {
                          children: Core__Option.getOr(Core__Option.map(member.agent.emailAddress, (function (v) {
                                      return Scalars.EmailAddress.toString(v);
                                    })), ""),
                          className: "col-span-3"
                        })
                  ],
                  className: "grid grid-cols-4 gap-4"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: "Display name:",
                                className: "font-semibold"
                              }),
                          className: "col-span-1"
                        }),
                    JsxRuntime.jsx("div", {
                          children: member.agent.displayName,
                          className: "col-span-3"
                        })
                  ],
                  className: "grid grid-cols-4 gap-4"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: "Role:",
                                className: "font-semibold"
                              }),
                          className: "col-span-1"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(AccountMemberUtils.RoleSelectComponent.make, {
                                      onChange: (function (value) {
                                          form.updateRole((function (param, value) {
                                                  return {
                                                          role: value
                                                        };
                                                }), value !== undefined ? value.value : undefined);
                                        }),
                                      result: tmp$1,
                                      value: Core__Option.map(form.input.role, (function (v) {
                                              return AccountMemberUtils.SelectOpts.make(v);
                                            }))
                                    })
                              }),
                          className: "col-span-3"
                        })
                  ],
                  className: "grid grid-cols-4 gap-4"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                onClick: (function (extra) {
                                    return Form__Helpers.preventDefault(form.submit, extra);
                                  }),
                                disabled: match[1] || form.submitting,
                                children: "Save"
                              }),
                          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                onClick: (function (param) {
                                    setIsEditing(function (param) {
                                          return false;
                                        });
                                  }),
                                children: "Cancel"
                              })
                        ],
                        className: "flex flex-row space-x-2"
                      }),
                  className: "grid grid-cols-4 gap-4"
                })
          ],
          className: "flex flex-col space-y-4 w-full"
        });
  } else {
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: name,
                                  className: "font-semibold"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: name === member.agent.displayName ? null : JsxRuntime.jsx("div", {
                                          children: member.agent.displayName
                                        }),
                                  className: "text-gray-500"
                                })
                          ]
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: Core__Option.getOr(Core__Option.map(member.agent.emailAddress, (function (e) {
                                                          return Scalars.EmailAddress.toString(e);
                                                        })), null),
                                              className: ""
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: Core__Option.getOr(Core__Option.map(Core__Option.flatMap(member.role, (function (r) {
                                                              return accountMemberRole_decode(r);
                                                            })), (function (r) {
                                                          return AccountMemberUtils.roleToString(r);
                                                        })), null),
                                              className: "text-gray-500"
                                            })
                                      ],
                                      className: ""
                                    }),
                                className: "col-span-3 flex justify-between"
                              })
                        })
                  ],
                  className: "flex flex-row space-x-4"
                }),
            JsxRuntime.jsx("div", {
                  children: memberCanBeEdited ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Tooltip.make, {
                                  label: canEdit ? "Edit the member's role" : "Only the account owner can edit member roles",
                                  children: JsxRuntime.jsx("span", {
                                        children: JsxRuntime.jsx(IconButton.make, {
                                              icon: "pencil",
                                              onPress: (function () {
                                                  setIsEditing(function (param) {
                                                        return true;
                                                      });
                                                }),
                                              title: "Edit user",
                                              disabled: !canEdit
                                            })
                                      })
                                }),
                            JsxRuntime.jsx(Tooltip.make, {
                                  label: canEdit ? "Remove the member from your account" : "Only the account owner can remove members",
                                  children: JsxRuntime.jsx("span", {
                                        children: JsxRuntime.jsx(IconButton.make, {
                                              icon: "trash",
                                              onPress: (function () {
                                                  setConfirmRemoveDialogOpen(function (param) {
                                                        return true;
                                                      });
                                                }),
                                              title: "Remove user",
                                              disabled: !canEdit || match$1[1]
                                            })
                                      })
                                })
                          ],
                          className: "flex flex-row space-x-1"
                        }) : null
                })
          ],
          className: "flex flex-row space-x-4 justify-between w-full"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(SubusersPageAccountsListItem$ConfirmRemoveDialog, {
                      isOpen: match$6[0],
                      onConfirm: (function () {
                          removeMember$1();
                          setConfirmRemoveDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      onCancel: (function () {
                          setConfirmRemoveDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      name: name
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Avatar__Jsx3.make, {
                            src: match$7 !== undefined ? match$7.url : AvatarSrcUrl.place_holder,
                            name: name,
                            size: "tiny"
                          })
                    }),
                tmp
              ],
              className: "flex flex-row space-x-4 my-4 items-start"
            });
}

var make = SubusersPageAccountsListItem;

exports.ConfirmRemoveDialog = ConfirmRemoveDialog;
exports.FormConfig = FormConfig;
exports.AccountFragment = AccountFragment;
exports.MemberFragment = MemberFragment;
exports.UpdateMemberV5Mutation = UpdateMemberV5Mutation;
exports.RemoveMemberV5Mutation = RemoveMemberV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
